module.exports = __webpack_public_path__ + "static/media/6.886f7519.jpg";